// src/reducers/petsReducer.js

import { createListReducer } from "./createListReducer";

export const initialState = {
  pets: [],
  loading: false,
  error: '',
  order: 'asc', // 'asc' or 'desc'
  orderBy: 'name', // default sort column
  page: 0,
  rowsPerPage: 25,
  totalPets: 0,
};

export const petsReducer = createListReducer('pets', 'totalPets');